import React, {useCallback, useEffect} from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {Modal, CtaButton, zIndex} from '@optimaxdev/design-system';
import {connect} from 'react-redux';

import {TYP_SMS_POPUP} from 'constants/analytics/events/typ';
import {ApplicationStoreType} from 'desktop/store';
import {disableScroll} from 'libs/utils/utils';

import {isOrderContainsSomeContactLenses} from '../../store/selectors/orderItems/orderItems';

import s from './reorderPopupSuccessPage.scss';

const agreementText = (
    <>
        By clicking on this button, you agree to receive recurring autodialed offers and marketing
        text messages from GlassesUSA.com at the cell phone number used when signing up. This
        consent is not a condition of any purchase. Message & data rates may apply. Message
        frequency varies. At any time reply STOP to cancel and HELP for customer service. View our{' '}
        <a className={s.link} href="/terms-and-conditions" target="_blank">
            Terms of Use
        </a>{' '}
        and{' '}
        <a className={s.link} href="/privacy-policy" target="_blank">
            Privacy Policy
        </a>
        .
    </>
);

export type PropsType = {
    isOpen: boolean;
    setVisible: (isOpen: boolean) => void;
    hasOrderContactLenses: boolean;
};

/**
 * Reorder popup on success page, notice about make super fast your next order
 * @returns {React.ReactElement} reorder popup success page
 */
export const ReorderPopupSuccessPage: React.FC<PropsType> = ({
    hasOrderContactLenses,
    isOpen,
    setVisible,
}) => {
    useEffect(() => {
        if (hasOrderContactLenses) {
            sendDesktopAnalyticsEvent(TYP_SMS_POPUP, 'Display', false);
            setVisible(true);
            disableScroll(true);
        }
    }, [hasOrderContactLenses]);

    const sendAllowSmsReorder = useCallback(() => {
        setVisible(false);
        disableScroll(false);
        sendDesktopAnalyticsEvent(TYP_SMS_POPUP, 'Update Me');
    }, []);

    const closePopup = useCallback(() => {
        setVisible(false);
        disableScroll(false);
    }, [setVisible]);

    return (
        <Modal isOpen={isOpen} onRequestClose={closePopup} overlay="dark" zIndex={zIndex.tooltip}>
            <div className={s.wrapper}>
                <div className={s.modal}>
                    <h3 className={s.title}>Make your next order super easy!</h3>
                    <p className={s.description}>
                        We’ll text you a 1-click reorder link when it’s time to restock on contacts.
                    </p>
                    <CtaButton
                        className={s.btn}
                        colorName="secondary"
                        isFull={false}
                        onClick={sendAllowSmsReorder}
                        size="large"
                    >
                        Update Me via Text
                    </CtaButton>
                </div>
                <p className={s.bottomDescription}>{agreementText}</p>
            </div>
        </Modal>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType) => ({
    hasOrderContactLenses: isOrderContainsSomeContactLenses(store),
});

export const ReorderPopupSuccessPageConnected = connect(mapStateToProps)(ReorderPopupSuccessPage);
